import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/admin'
import Login from '@/views/admin/login'
import Today from '@/views/today'
import User from '@/views/user'
import Customer from '@/views/customer'
import Role from '@/views/role'
import Menu from '@/views/menu'
import Account from '@/views/account'
import Transfer from '@/views/transfer'
import Out from '@/views/out'
import Permission from '@/views/permission'
import OutVerify from '@/views/outVerify'
import Sms from '@/views/sms'
import OutCategory from '@/views/outCategory'
import WechatAuth from '@/views/wechat/auth'
import AttendancePage from '@/views/admin/attendance'
import Schedule from '@/views/schedule'
import Attendance from '@/views/attendance'
import Analysis from '@/views/attendance/analysis'
import WechatLogin from '@/views/wechat/login'
import Contribute from '@/views/contribute'
import Order from '@/views/order'
import newOrder from '@/views/order/newOrder'
import EditOrder from '@/views/order/editOrder'
import Product from '@/views/product'
import OrderView from '@/views/order/view'
import Payment from '@/views/payment'
import PaymentDetail from '@/views/paymentDetail'
import CustomerPayment from '@/views/payment/customer'
import PaymentVerify from '@/views/paymentVerify'
import ReporterAnalysis from '@/views/reporter/analysis'
import Debt from '@/views/reporter/debt'
import TransferVerify from '@/views/transferVerify'
import CustomerReporter from '@/views/reporter/customer'
import Invoice from '@/views/invoice'
import Release from '@/views/release'
import OutAnalysis from '@/views/reporter/out'

import session from 'utils/session'

Vue.use(Router)
let router = new Router({
  routes: [
    {
      path: '/',
      name: '首页',
      component: Index,
      redirect: '/admin',
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wechat/auth',
      name: '公众号授权',
      component: WechatAuth,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/wechat/login',
      name: '扫码登录',
      component: WechatLogin,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/attendance',
      name: '考勤',
      component: AttendancePage,
      meta: {
        requireAuth: false
      }
    },
    {
      path: '/admin',
      name: '后台首页',
      redirect: '/admin/today',
      component: Index,
      meta: {
        requireAuth: false
      },
      children: [
        {
          path: '/admin/today',
          name: 'Today',
          component: Today,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/user',
          name: '用户列表',
          component: User,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/customer',
          name: '客户列表',
          component: Customer,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/role',
          name: '角色列表',
          component: Role,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/menu',
          name: '菜单列表',
          component: Menu,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/account',
          name: '账户列表',
          component: Account,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/transfer',
          name: '转账列表',
          component: Transfer,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/out',
          name: '支出列表',
          component: Out,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/permission',
          name: '权限列表',
          component: Permission,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/outVerify',
          name: '支出审核列表',
          component: OutVerify,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/sms',
          name: '短信列表',
          component: Sms,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/outCategory',
          name: '支出分类列表',
          component: OutCategory,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/schedule',
          name: '班次列表',
          component: Schedule,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/attendance',
          name: '考勤列表',
          component: Attendance,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/contribute',
          name: '出资列表',
          component: Contribute,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/order',
          name: '订单列表',
          component: Order,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/order/newOrder',
          name: '下单',
          component: newOrder,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/order/editOrder',
          name: '订单修改',
          component: EditOrder,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/attendance/analysis',
          name: '考勤统计',
          component: Analysis,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/product',
          name: '产品列表',
          component: Product,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/order/view',
          name: '查看订单',
          component: OrderView,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/payment',
          name: '付款列表',
          component: Payment,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/paymentDetail',
          name: '付款详情列表',
          component: PaymentDetail,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/payment/customer',
          name: '客户账务管理',
          component: CustomerPayment,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/paymentVerify',
          name: '付款审核列表',
          component: PaymentVerify,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/reporter/analysis',
          name: '收支统计',
          component: ReporterAnalysis,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/reporter/debt',
          name: '欠款明细',
          component: Debt,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/transferVerify',
          name: '转账审核列表',
          component: TransferVerify,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/reporter/customer',
          name: '客户订单统计',
          component: CustomerReporter,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/invoice',
          name: '发票列表',
          component: Invoice,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/release',
          name: '版本列表',
          component: Release,
          meta: {
            requireAuth: true
          }
        },
        {
          path: '/admin/outAnalysis',
          name: '支出分析',
          component: OutAnalysis,
          meta: {
            requireAuth: true
          }
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  const user = session.getSession('user')
  // 已登录
  if (user) {
    if (router.app.$options.store.getters.user.id === undefined) {
      router.app.$options.store.dispatch('setUser', user)
      router.app.$options.store.dispatch(
        'setMenuTree',
        session.getSession('menuTree')
      )
    }
    if (to.meta.requireAuth) {
      // 去掉path后的斜线
      if (
        user.role.menus.some(
          x => x.url === to.path || x.url === to.path.slice(0, -1)
        )
      ) {
        next()
      } else {
        router.app.$toast.error('您无权访问该页面')
      }
    } else {
      next()
    }
  } else {
    if (to.meta.requireAuth) {
      router.app.$router.replace('/login')
      next()
    } else {
      next()
    }
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js